var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position-relative",staticStyle:{"height":"100dvh","background":"lightgray"}},[_c('section',{staticClass:"su-mobile-container"},[_c('SignupForm',{attrs:{"signinCheckData":_vm.signinCheckData},on:{"next":function($event){return _vm.$emit('next')}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }